import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function SessoesPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Secções'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoLicenciamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Licenciamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoCertificadoProdutoControlo'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Certificados Para Produtos Controlados'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoImportação'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Importação'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoDesalfandegamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Desalfandegamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoExpediente'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Expediente'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoFarmacovigilância'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Farmacovigilância'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoControleQualidade'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Controlo de Qualidade'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'secçãoMedicamentos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Secção de Medicamentos'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
